/**
 * LTI Enrollment Classes
 * LTI Enroll Class for Students
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';

/**
* EnrollmentActions service.
* @module api/EnrollmentActionsApi
* @version 2.0.0
*/
export default class EnrollmentActionsApi {

    /**
    * Constructs a new EnrollmentActionsApi. 
    * @alias module:api/EnrollmentActionsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Cancel enrollment class student
     * @param {String} studentId 
     * @param {Number} eventId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    enrollmentClassesControllerCancelEnrollmentClassesWithHttpInfo(studentId, eventId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling enrollmentClassesControllerCancelEnrollmentClasses");
      }
      // verify the required parameter 'eventId' is set
      if (eventId === undefined || eventId === null) {
        throw new Error("Missing the required parameter 'eventId' when calling enrollmentClassesControllerCancelEnrollmentClasses");
      }

      let pathParams = {
        'student_id': studentId,
        'event_id': eventId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/lti/enrollmentClasses/cancel_enrollment_class/{student_id}/event/{event_id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Cancel enrollment class student
     * @param {String} studentId 
     * @param {Number} eventId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    enrollmentClassesControllerCancelEnrollmentClasses(studentId, eventId) {
      return this.enrollmentClassesControllerCancelEnrollmentClassesWithHttpInfo(studentId, eventId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Enroll class student
     * @param {String} studentId 
     * @param {Number} eventId 
     * @param {Number} formativeActionId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    enrollmentClassesControllerEnrollmentClassesWithHttpInfo(studentId, eventId, formativeActionId) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling enrollmentClassesControllerEnrollmentClasses");
      }
      // verify the required parameter 'eventId' is set
      if (eventId === undefined || eventId === null) {
        throw new Error("Missing the required parameter 'eventId' when calling enrollmentClassesControllerEnrollmentClasses");
      }
      // verify the required parameter 'formativeActionId' is set
      if (formativeActionId === undefined || formativeActionId === null) {
        throw new Error("Missing the required parameter 'formativeActionId' when calling enrollmentClassesControllerEnrollmentClasses");
      }

      let pathParams = {
        'student_id': studentId,
        'event_id': eventId,
        'formative_action_id': formativeActionId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/lti/enrollmentClasses/enrollment_classes/{student_id}/event/{event_id}/formative_action/{formative_action_id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Enroll class student
     * @param {String} studentId 
     * @param {Number} eventId 
     * @param {Number} formativeActionId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    enrollmentClassesControllerEnrollmentClasses(studentId, eventId, formativeActionId) {
      return this.enrollmentClassesControllerEnrollmentClassesWithHttpInfo(studentId, eventId, formativeActionId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Cancel enrollment class student
     * @param {String} studentId 
     * @param {Number} eventId 
     * @param {Number} formativeActionId 
     * @param {Number} eventIdOld 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    enrollmentClassesControllerUpdateEnrollmentClassesWithHttpInfo(studentId, eventId, formativeActionId, eventIdOld) {
      let postBody = null;
      // verify the required parameter 'studentId' is set
      if (studentId === undefined || studentId === null) {
        throw new Error("Missing the required parameter 'studentId' when calling enrollmentClassesControllerUpdateEnrollmentClasses");
      }
      // verify the required parameter 'eventId' is set
      if (eventId === undefined || eventId === null) {
        throw new Error("Missing the required parameter 'eventId' when calling enrollmentClassesControllerUpdateEnrollmentClasses");
      }
      // verify the required parameter 'formativeActionId' is set
      if (formativeActionId === undefined || formativeActionId === null) {
        throw new Error("Missing the required parameter 'formativeActionId' when calling enrollmentClassesControllerUpdateEnrollmentClasses");
      }
      // verify the required parameter 'eventIdOld' is set
      if (eventIdOld === undefined || eventIdOld === null) {
        throw new Error("Missing the required parameter 'eventIdOld' when calling enrollmentClassesControllerUpdateEnrollmentClasses");
      }

      let pathParams = {
        'student_id': studentId,
        'event_id': eventId,
        'formative_action_id': formativeActionId,
        'event_id_old': eventIdOld
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/lti/enrollmentClasses/update_enrollment_class/{student_id}/event/{event_id}/formative_action/{formative_action_id}/event_cancel_id/{event_id_old}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Cancel enrollment class student
     * @param {String} studentId 
     * @param {Number} eventId 
     * @param {Number} formativeActionId 
     * @param {Number} eventIdOld 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    enrollmentClassesControllerUpdateEnrollmentClasses(studentId, eventId, formativeActionId, eventIdOld) {
      return this.enrollmentClassesControllerUpdateEnrollmentClassesWithHttpInfo(studentId, eventId, formativeActionId, eventIdOld)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
